import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../../utils/auth';

const withModeratorAuth = (WrappedComponent) => {
  return function WithModeratorAuth(props) {
    const user = auth.getUser();
    const userType = auth.getUserType();
    
    
    if (!user || userType !== 'moderator') {
      return <Navigate to="/login" />;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withModeratorAuth; 